.dropdownButton {
  button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.customFillAndBook {
  width: 100%;
}

.fillAndBook {
  flex: 1;
}
